module.exports = __webpack_public_path__ + "static/img/join_2.030da5e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/join_2.png
// module id = OTVD
// module chunks = 1